export default __webpack_public_path__ + "static/media/music image.b417d01e.jpg";